import { Construction } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Card, Empty, PageHeader } from '@concours/ui'

export function ComingSoonPage({ navKey, phase }: { navKey: string; phase: number }) {
  const { t } = useTranslation()
  const page = t(navKey)
  return (
    <>
      <PageHeader eyebrow={t('comingSoon.eyebrow')} title={t('comingSoon.title', { page })} />
      <Card>
        <Empty
          icon={<Construction aria-hidden="true" />}
          title={page}
          description={t('comingSoon.description', { phase })}
        />
      </Card>
    </>
  )
}
